var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 18,
    viewBox: "0 0 13.5 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375,18h11.25V4.5H3.375ZM4.5,5.625h9v11.25h-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,2.25V0H6.75V2.25H2.25V3.375h13.5V2.25Zm-1.125,0H7.875V1.125h2.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.125,
    height: 6.75,
    transform: "translate(6.437 7.875)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.125,
    height: 6.75,
    transform: "translate(10.437 7.875)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.63efb16cc5db774f09621cea4876070f.svg";